module.exports = __webpack_public_path__ + "img/w36b.6081f93d.jpg";